<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 m-0">
        <div class="p-2" [ngClass.xl]="'d-flex justify-content-between'" [ngClass.md]="'d-flex justify-content-between'">
          <div class="p-0" [ngClass.sm]="'col-12'">
            <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchTutorial()" />
          </div>
          <div [ngClass.sm]="'col-12 text-right mt-1 pr-0'" *ngIf="_authenticationService.hasCapability('add_tutorial')">
            <a class="btn btn-outline-primary text-primary" (click)="openModal(addNewTutorial, null)">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>
      <div class="card-body p-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [rowHeight]="_utilService.isDesktop ? 60 : 100"
          [footerHeight]="50"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rows]="filteredTutorialList"
        >
          <ngx-datatable-column [name]="'ID' | translate" prop="id" width="20" *ngIf="isDevMode && _utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>{{ row.id }}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TUTORIAL' | translate" prop="title" width="800" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>{{ row.title }}</div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="-_authenticationService.hasCapability('edit_tutorial')">
                  <a class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left" (click)="openModal(editCurrentTutorial, row)">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </a>
                </button>
                <button
                  class="bg-transparent border-0 text-danger remove-item"
                  [ngbTooltip]="'DELETE' | translate"
                  placement="left"
                  (click)="deleteTutorial(row)"
                  *ngIf="-_authenticationService.hasCapability('delete_tutorial')"
                >
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'TUTORIAL' | translate" prop="title" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      {{ row.title }}
                    </div>
                    <div ngClass="mr-1">
                      <button class="bg-transparent border-0 text-secondary mr-1" *ngIf="-_authenticationService.hasCapability('edit_tutorial')">
                        <a class="text-secondary text-center" [ngbTooltip]="'EDIT' | translate" placement="left" (click)="openModal(editCurrentTutorial, row)">
                          <i [data-feather]="'edit-2'" size="19"></i>
                        </a>
                      </button>
                      <button
                        class="bg-transparent border-0 text-danger remove-item"
                        [ngbTooltip]="'DELETE' | translate"
                        placement="left"
                        (click)="deleteTutorial(row)"
                        *ngIf="-_authenticationService.hasCapability('delete_tutorial')"
                      >
                        <i [data-feather]="'trash-2'" size="19"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!--modal ADD-->
<ng-template #addNewTutorial>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.INSERT_TUTORIAL" | translate }}</h3>
    <form>
      <!-- titolo -->
      <div class="form-group">
        <label for="addTitle">{{ "TITLE" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" class="form-control" name="title" id="addTitle" [(ngModel)]="newTitle" required />
        <div class="font-error" *ngIf="showModalError && (!newTitle || newTitle.length < 1)">{{ "ERRORS.FIELD_TITLE" | translate }}</div>
      </div>

      <!-- descrizione -->
      <div class="form-group">
        <label for="addDescription">{{ "DESCRIPTION" | translate }}</label>
        <textarea class="form-control" name="description" id="addDescription" cols="30" rows="8" [placeholder]="'INSERT_DESCRIPTION_TUTORIAL' | translate" [(ngModel)]="newDescription"></textarea>
      </div>

      <!-- file video mp4-->
      <div class="form-group">
        <label for="addVideoMp4">{{ "FILE" | translate }} .mp4<sup class="text-danger">*</sup></label>
        <div class="custom-file" *ngIf="!video_list[0]">
          <input class="custom-file-input" type="file" lang="it" id="addVideoMp4" (change)="addVideoToList($any($event).target.files)" accept="video/mp4" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
        <span *ngIf="video_list[0]" class="d-flex w-fit mr-05 mb-05 badge badge-light-secondary">
          <div class="cursor-pointer">{{ "VIDEO_FILE_MP4" | translate }}</div>
          <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(0)">
            <i [data-feather]="'x'" class="text-danger" size="18"></i>
          </div>
        </span>
      </div>

      <!-- file video ogg-->
      <div class="form-group">
        <label for="addVideoOgg">{{ "FILE" | translate }} .ogg<sup class="text-danger">*</sup></label>
        <div class="custom-file" *ngIf="!video_list[1]">
          <input class="custom-file-input" type="file" lang="it" id="addVideoOgg" (change)="addVideoToList($any($event).target.files)" accept=".ogg" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
        <span *ngIf="video_list[1]" class="d-flex w-fit mr-05 mb-05 badge badge-light-secondary">
          <div class="cursor-pointer">{{ "VIDEO_FILE_OGG" | translate }}</div>
          <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(1)">
            <i [data-feather]="'x'" class="text-danger" size="18"></i>
          </div>
        </span>
      </div>

      <!-- file video webm-->
      <div class="form-group">
        <label for="addVideoWebM">{{ "FILE" | translate }} .webm<sup class="text-danger">*</sup></label>
        <div class="custom-file" *ngIf="!video_list[2]">
          <input class="custom-file-input" type="file" lang="it" id="addVideoWebM" (change)="addVideoToList($any($event).target.files)" accept="video/webm" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
        <span *ngIf="video_list[2]" class="d-flex w-fit mr-05 mb-05 badge badge-light-secondary">
          <div class="cursor-pointer">{{ "VIDEO_FILE_WEBM" | translate }}</div>
          <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(2)">
            <i [data-feather]="'x'" class="text-danger" size="18"></i>
          </div>
        </span>
      </div>
    </form>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" aria-label="Close" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="addTutorial()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "ADD" | translate }}
    </button>
  </div>
</ng-template>

<!--modal EDIT-->
<ng-template #editCurrentTutorial>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="modalClose()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" tabindex="0">
    <h3>{{ "MODAL.EDIT_TUTORIAL" | translate }}</h3>
    <form>
      <!-- titolo -->
      <div class="form-group">
        <label for="title">{{ "TITLE" | translate }}<sup class="text-danger">*</sup></label>
        <input type="text" class="form-control" name="title" id="title" [(ngModel)]="current_tutorial.title" required />
        <div class="font-error" *ngIf="showModalError && (!current_tutorial.title || current_tutorial.title.length < 1)">{{ "ERRORS.FIELD_TITLE" | translate }}</div>
      </div>

      <!-- descrizione -->
      <div class="form-group">
        <label for="description">{{ "DESCRIPTION" | translate }}</label>
        <textarea class="form-control" name="description" id="description" cols="30" rows="8" [placeholder]="'INSERT_DESCRIPTION_TUTORIAL' | translate" [(ngModel)]="current_tutorial.description"></textarea>
      </div>

      <!-- file video mp4 -->
      <div class="form-group">
        <label>{{ "FILE" | translate }} .mp4<sup class="text-danger">*</sup></label>
        <div *ngIf="current_tutorial.videos[0]?.length > 0" class="d-flex mb-05">
          <span class="d-flex w-fit mr-05 badge badge-light-secondary">
            <div class="cursor-pointer">{{ "VIDEO_FILE_MP4" | translate }}</div>
            <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(0)">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
          </span>
          <div class="badge badge-light-secondary cursor-pointer" (click)="showVideo()">
            <span class="mr-05">{{ "PLAY_VIDEO" | translate }}</span>
            <i [data-feather]="'play'" class="text-secondary" size="18"></i>
          </div>
        </div>
        <div class="custom-file" *ngIf="current_tutorial.videos[0]?.length < 1">
          <input class="custom-file-input" type="file" lang="it" id="editVideoMp4" (change)="editVideoToList($any($event).target.files)" accept="video/mp4" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>

      <!-- file video ogg -->
      <div class="form-group">
        <label>{{ "FILE" | translate }} .ogg<sup class="text-danger">*</sup></label>
        <div *ngIf="current_tutorial.videos[1]?.length > 0" class="d-flex mb-05">
          <span class="d-flex w-fit mr-05 badge badge-light-secondary">
            <div class="cursor-pointer">{{ "VIDEO_FILE_OGG" | translate }}</div>
            <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(1)">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
          </span>
          <div class="badge badge-light-secondary cursor-pointer" (click)="showVideo()">
            <span class="mr-05">{{ "PLAY_VIDEO" | translate }}</span>
            <i [data-feather]="'play'" class="text-secondary" size="18"></i>
          </div>
        </div>

        <div class="custom-file" *ngIf="current_tutorial.videos[1]?.length < 1">
          <input class="custom-file-input" type="file" lang="it" id="editVideoOgg" (change)="editVideoToList($any($event).target.files)" accept=".ogg" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>

      <!-- file video webm -->
      <div class="form-group">
        <label>{{ "FILE" | translate }} .webm<sup class="text-danger">*</sup></label>
        <div *ngIf="current_tutorial.videos[2]?.length > 0" class="d-flex mb-05">
          <span class="d-flex w-fit mr-05 badge badge-light-secondary">
            <div class="cursor-pointer">{{ "VIDEO_FILE_WEBM" | translate }}</div>
            <div class="ml-05 cursor-pointer" (click)="softDeleteVideo(2)">
              <i [data-feather]="'x'" class="text-danger" size="18"></i>
            </div>
          </span>
          <div class="badge badge-light-secondary cursor-pointer" (click)="showVideo()">
            <span class="mr-05">{{ "PLAY_VIDEO" | translate }}</span>
            <i [data-feather]="'play'" class="text-secondary" size="18"></i>
          </div>
        </div>
        <div class="custom-file" *ngIf="current_tutorial.videos[2]?.length < 1">
          <input class="custom-file-input" type="file" lang="it" id="editVideoWebM" (change)="editVideoToList($any($event).target.files)" accept="video/webm" />
          <label class="custom-file-label">{{ "SELECT_FILE" | translate }}</label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer d-flex justify-content-center">
    <button type="button" class="btn btn-outline-primary w-150" (click)="modalClose()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button (click)="editTutorial()" type="submit" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
